import React from 'react';
import { useCloudinary } from '@hooks/Cloudinary/useCloudinary';
import { buildImageSources } from './ResponsiveImage.utils';
import { HeroImagesProps } from './HeroImages.types';
import { getHiddenMedia, getPublicId, getSizes, getVariants } from './HeroImages.utils';
import * as S from './HeroImages.styles';

export const HeroImages = ({
  image,
  mobileImage,
  cropOnSmallScreens = false,
  halfScreen = false,
  alt,
}: HeroImagesProps) => {
  const { getProcessedImage } = useCloudinary();
  const variants = getVariants(image, mobileImage, cropOnSmallScreens, halfScreen);

  return (
    <>
      {variants.map((variant, index) => {
        const earlierVariants = variants.slice(0, index);
        const sources = buildImageSources((width) =>
          getProcessedImage(getPublicId(variant.image) as string, {
            width,
            focusMethod: variant.image.focus ?? undefined,
            aspectRatio: variant.aspectRatio,
          })?.toURL(),
        );
        if (!sources) return null;
        return (
          <S.HeroImage
            key={`${getPublicId(variant.image)}-${variant.media ?? 'rest'}`}
            sizes={getSizes(variant, earlierVariants)}
            srcSet={sources.srcSet}
            src={sources.src}
            alt={alt}
            $media={variant.media}
            $hiddenMedia={getHiddenMedia(earlierVariants)}
          />
        );
      })}
    </>
  );
};
